import { useRouter } from 'next/router';
import { useState } from 'react';
import CoreAnimation from '@elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/CoreAnimation';
import Built from '../components/Built';
import ProductNav from '../../../common/ProductNav';
import { tabsValues } from '../../../config/pageConfig';
import Bundles from '../Bundles';
import Banner from '../components/Banner';
import Subscribe from '../components/Subscribe';
import FooterTcA from '../components/FooterTcA';
import SectionPhone from '../components/SectionPhone';
import Output from '../components/Output';
import OutputEu from '../euComponents/Output';
import Comparison from '../components/Comparison';
import CoverSectionEU from '../euComponents/CoverSectionEU';
import CoverSectionEU2 from '../euComponents/CoverSectionEU2';
import Explore from '../components/Explore';
import GraphicText from '../components/GraphicText';
import Automotive from '../components/Automotive';
import Automotive2 from '../components/Automotive2';
import CoverSection1 from '../components/CoverSection1';
import CoverSection2 from '../components/CoverSection2';
import CoverSection3 from '../components/CoverSection3';
import GraphicTextZero from '../components/GraphicTextZero';
import ChargeUp from '../components/ChargeUp';
import SectionImageText from '../components/SectionImageText';
import OnePictureEu from '../euComponents/OnePicture';
import OnePictureDe from '../euComponents/OnePictureDe';
import SectionImageTextEu from '../euComponents/SectionImageText';
import PageNavLeft from '../components/PageNavLeft';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import BottomAction from '@elem/compPage/delta-3-ultra-portable-power-station/pages/product/components/BottomAction';
import './reset.scss';
import getLocal from 'eco-design-reliance/getLocal';

export default function StatusItem() {
    const { query } = useRouter();
    const { t } = useLang('PageNavLeft');
    const searchTab = query?.tab;
    const { locale = 'us' } = getLocal();
    const isEu = ['eu', 'uk', 'de', 'fr', 'es', 'it', 'nl'].includes(locale)
    let defaultTab = 'Product';
    if (typeof searchTab === 'string' && tabsValues.includes(searchTab)) {
        defaultTab = searchTab;
    }
    const [activeTab, setActiveTab] = useState(defaultTab);
    const tabCallback = (tabValue: string) => {
        setActiveTab(tabValue);
    };
    return (
        <>
            <ProductNav activeTab={defaultTab} tabCallback={tabCallback} />
            {activeTab === 'Product' && !isEu && (
                <div className={styles.StatusA}>
                    <BottomAction pageType="classic" />
                    <Banner />

                    <CoreAnimation pageType="classic" />
                    {/* <Redfine />
                    <div id="OnePicture" className="range1">
                        <OnePicture />
                    </div> */}
                    <Subscribe />
                    <CoverSection1 />
                    <SectionImageText />
                    <ChargeUp />
                    <CoverSection2 />
                    <Output />
                    <GraphicTextZero />
                    <CoverSection3 />
                    <Automotive />
                    <Automotive2 />
                    <Built />
                    <GraphicText />
                    <SectionPhone />
                    <Comparison />
                    <Explore />
                    <FooterTcA />

                    <PageNavLeft
                        triggerElement=".delta-3-classic"
                        enterElement="#OnePicture"
                        whiteTextModules={[1, 2, 3]}
                        steps={[
                            { text: t('item1'), href: '#OnePicture' },
                            { text: t('item2'), href: '#videoSection1' },
                            { text: t('item3'), href: '#videoSection2' },
                            { text: t('item4'), href: '#videoSection3' },
                            { text: t('item5'), href: '#CompactAndPortable' },
                            { text: t('item6'), href: '#SectionPhone' },
                            { text: t('item7'), href: '#Compare' },
                        ]}
                    />
                </div>
            )}
            {activeTab === 'Product' && isEu && (
                <div className={styles.StatusA}>
                    <BottomAction pageType="classic" />
                    <Banner />
                    {/* 一图看懂 1 */}
                    {locale !== 'de' ? <OnePictureEu /> : <OnePictureDe />}
                    <CoverSectionEU />
                    {/* 2 */}
                    <OutputEu />
                    <CoverSectionEU2 />
                    {/* 3 */}
                    <SectionImageText />
                    <ChargeUp />
                    <GraphicText />
                    {locale !== 'de' && <SectionImageTextEu />}


                    <Automotive />
                    <Automotive2 />
                    <Built />
                    <SectionPhone />
                    <Comparison />
                    {/* <Explore /> */}
                    <FooterTcA />

                    <PageNavLeft
                        triggerElement=".delta-3-classic"
                        enterElement="#OnePicture"
                        steps={[
                            { text: t('item1'), href: '#OnePicture' },
                            { text: t('item2'), href: '#Output' },
                            { text: t('item3'), href: '#SectionImageText' },
                            { text: t('item4'), href: '#CompactAndPortable' },
                            { text: t('item5'), href: '#LFP' },
                            { text: t('item6'), href: '#SectionPhone' },
                            { text: t('item7'), href: '#Compare' },
                        ]}
                    />
                </div>
            )}
            {activeTab === 'Bundles' && (
                <>
                    <Bundles />
                </>
            )}
        </>
    );
}
